import React from "react";
import { List } from "antd";
import SearchResultListItem from "./SearchResultListItem";
import Text from "antd/lib/typography/Text";
import { ISearchResponse, TSearchResult } from "../../model/SearchResponse";
import { IRouter } from "../../../runtime/Router";
import { TSearchResultSummary } from "../../model/SearchResultSummary";
export interface SearchResultListProps {
  translate: any;
  router: IRouter;
  loading: boolean;
  searchResults?: ISearchResponse;
  summary?: TSearchResultSummary;
  currentPage: number;
  pageSize: number;
  showSearchResultDetails(item: TSearchResult): void;
  onItemClick(item: TSearchResult): void;
  onChangePage(page: number, pageSize?: number);
  onSelectIndex;
  currentLanguage?: string;
}
const SearchResultList: React.FC<SearchResultListProps> = (
  props: SearchResultListProps
) => {
  const {
    translate,
    searchResults,
    summary,
    showSearchResultDetails,
    onChangePage,
    currentPage,
    loading,
    pageSize,
    router,
    onItemClick,
    onSelectIndex,
    currentLanguage
  } = props;

  const [page, setPage] = React.useState<number>(currentPage || 1);
  const [_pageSize, setPageSize] = React.useState<number>(pageSize || 20);
  if (page !== currentPage) {
    setPage(currentPage);
  }
  if (pageSize !== _pageSize) {
    setPageSize(pageSize);
  }

  const renderListItems = () => {
    return searchResults?.formattedResults.map((item, index) => {
      return (
        <div
          className="card-list-container"
          onClick={() => {
            onItemClick(item);
            return true;
          }}
          key={`search-result-item-${index}`}
          id={`search-result-item-${item.id}`}
        >
          <SearchResultListItem
            item={item}
            router={router}
            translate={translate}
            showDetails={showSearchResultDetails}
            highlights={searchResults.highlights[item.id]}
            onSelectIndex={onSelectIndex}
            currentLanguage={currentLanguage}
          />
        </div>
      );
    });
  };
  return (
    <>
      <List
        loading={loading}
        size="large"
        className="search-results-list"
        locale={{
          emptyText: translate("data_grid.empty_text")
        }}
        pagination={{
          position: "both",
          current: page,

          showLessItems: true,
          defaultPageSize: 20,
          hideOnSinglePage: (summary?.resultCount || 0) <= pageSize,
          showSizeChanger: true,
          pageSize: _pageSize,
          onChange: (pageNumber, pageSize) => {
            setPage(pageNumber);
            setPageSize(pageSize);
            onChangePage(pageNumber, pageSize);
          },
          total: summary?.resultCount || 0,
          showTotal: (total, range) => (
            <Text>{`${translate("data_grid.pagination.showing")} ${
              range[0]
            } ${translate("data_grid.pagination.to")} ${range[1]} ${translate(
              "data_grid.pagination.total"
            )} ${total}`}</Text>
          )
        }}
        dataSource={searchResults?.formattedResults}
      >
        {renderListItems()}
      </List>
    </>
  );
};
export default SearchResultList;
